import CommonConfig from './_Common';
import JavascriptSDKConfig from './_JavascriptSDK';

export default {
  blocks: [CommonConfig, JavascriptSDKConfig],
};
